<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { onDestroy, onMount } from 'svelte';
import uiStore from '../utils/UIStore';
let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

export let prompts = [];
export let callback = () => console.log('No callback is given');
export let translationKey = 'examplePromptsChat';

let selectedPrompts = [];
let selectedIndices = [];

function shufflePrompts() {
  let indices = new Set();
  const numToSelect = Math.min(3, prompts.length);
  while (indices.size < numToSelect) {
    const randomIndex = Math.floor(Math.random() * prompts.length);
    indices.add(randomIndex);
  }

  selectedIndices = Array.from(indices);
}

const unsubscribe = uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

$: if (uiTexts && uiTexts[translationKey] && selectedIndices.length > 0) {
  selectedPrompts = selectedIndices.map((index) => uiTexts[translationKey][index]);
}

onMount(() => {
  shufflePrompts();
});

onDestroy(() => {
  unsubscribe();
});
</script>

<div class="prompts-container">
    <span
        style="font-weight: 600;color: #555; display:flex;    align-items: center;
    gap: 3px;"
        >{uiTexts.examplePrompts.title}
        {#if prompts.length > 3}
            <button
                title={uiTexts.examplePrompts.changeSelectionTooltip}
                style="background-image: url(/static/app-icon-reload.svg); background-color:white;     background-repeat: no-repeat;"
                on:click={shufflePrompts}
            ></button>
        {/if}
    </span>

    <div
        style="display: flex;
    gap: 30px;"
    >
        {#each selectedPrompts as prompt}
            <button
                class="prompt"
                on:click={() => callback(prompt)}
                title={prompt.prompt}
            >
                <div class="text-content">
                    <span class="text"> {prompt["samplePrompt"]}</span>
                </div>
                {#if prompt["source_1"] != undefined || prompt["source_2"] != undefined || prompt["source_3"] != undefined}
                    <div class="filter">
                        {#if prompt["source_1"] != undefined && prompt["source_1"] != ""}
                            <div class="source">
                                {prompt["source_1"]}
                                {#if prompt["dateFilter_1"] != ""}
                                    ({prompt["dateFilter_1"]})
                                {/if}
                            </div>
                        {/if}
                        {#if prompt["source_2"] != undefined && prompt["source_2"] != ""}
                            <div class="source">
                                {prompt["source_2"]}
                                {#if prompt["dateFilter_2"] != ""}
                                    ({prompt["dateFilter_2"]})
                                {/if}
                            </div>
                        {/if}
                        {#if prompt["source_3"] != undefined && prompt["source_3"] != ""}
                            <div class="source">
                                {prompt["source_3"]}
                                {#if prompt["dateFilter_3"] != ""}
                                    ({prompt["dateFilter_3"]})
                                {/if}
                            </div>
                        {/if}
                    </div>
                {/if}
            </button>
        {/each}
    </div>
</div>

<style scoped>
    .text-content {
        display: flex;
        flex-direction: column;
        min-width: 0; /* Wichtig für `text-overflow: ellipsis` */
    }

    .text {
        word-wrap: break-word;
        overflow-wrap: break-word;
        color: #555;
    }
    .filter {
        display: flex;
        gap: 5px;
        flex-shrink: 0; /* Verhindert, dass Icons schrumpfen */
        flex-wrap: wrap;
        width: auto;
        margin-top: 15px;
    }

    .prompts-container {
        text-align: left;
        display: flex;
        flex-direction: column;
        gap: 5px;
        max-width: 770px;
        width: 100%;
        margin-top: 20px;
    }

    .prompt {
        background-color: #f9f9f9;
        text-align: left;
        width: 100%;
        color: rgb(100, 100, 100);
        text-transform: none;
        font-weight: 400;
        display: flex;
        justify-content: start;
        padding: 16px;
        flex-direction: column;
        align-items: start;
        justify-content: space-between;
        border-radius: 12px !important;
        border: 1px solid #e5e5e5;
        transition: all 0.2s;
        cursor: pointer;
    }

    .prompt:hover {
        transform: translateY(-2px);
        color: var(--main-color);
        background-color: #f0f0f0;
    }

    .source {
        background-color: rgb(219, 219, 219);
        color: black;
        padding: 5px 10px;
        font-size: 0.8rem;
        height: 29px;
        width: max-content;
        border-radius: 8px;
    }

    @media screen and (max-width: 640px) {
        .prompts-container {
            margin-top: 12px;
        }

        .prompts-container > div {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
    }
</style>
